import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const timelineApi = createApi({
  reducerPath: "timelineApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
  tagTypes: ["Timeline"],
  endpoints: (b) => ({
    getTimelineEndDate: b.query<Date, void>({
      query: () => ({ url: `timeline/` }),
      transformResponse: (response: string) => new Date(response),
      providesTags: [{ type: "Timeline", id: "END" }],
    }),
  }),
});

export const { useGetTimelineEndDateQuery, useLazyGetTimelineEndDateQuery } = timelineApi;

